<template>
  <div class="c-table" ref="shutdowndetailtable">
    <el-table class="common-el-table-styles" v-loading="loading" :data="data" :height="height" border stripe>
      <slot></slot>
      <template slot="empty">
        <no-data />
      </template>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
      >
        <template slot-scope="scope">
          <div v-if="col.key === 'control'">
            <el-button type="text" size="small" @click="$emit('on-retry', scope.row)" v-if="scope.row.execStatus === -1">重试</el-button>
          </div>
          <span v-else-if="col.key === 'opType'">{{ scope.row[col.key] | opType }}</span>
          <span v-else-if="col.key === 'imageDetailName'">{{ scope.row[col.key] || '————' }}</span>
          <span v-else-if="col.key === 'execStatus'">{{ scope.row[col.key] | transStatus(scope.row) }}</span>
          <span v-else-if="col.key === 'lastOperateTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'shutdowndetailtable',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    columns: {
      type: Array
    },
    height: {
      type: Number
    }
  },
  filters: {
    opType(val) {
      let type
      switch (val) {
        case 0:
          type = '暂停计划'
          break
        case -1:
          type = '删除计划'
          break
        case 1:
          type = '启用计划'
          break
        case 2:
          type = '暂停素材'
          break
        case 3:
          type = '删除素材'
          break
        case 4:
          type = '启用素材'
          break
        default:
          type = '未知'
          break
      }
      return type
    },
    transStatus(val, row) {
      let msgInfo
      switch (val) {
        case 0:
          msgInfo = '进行中'
          break
        case 1:
          msgInfo = '成功'
          break
        case -1:
          msgInfo = '失败,' + row.execMsg
          break
        default:
          msgInfo = '未知'
          break
      }
      return msgInfo
    }
  }
}
</script>
